import { render } from "./AkahonSideMenu.vue?vue&type=template&id=4c223664"
import script from "./AkahonSideMenu.vue?vue&type=script&lang=js"
export * from "./AkahonSideMenu.vue?vue&type=script&lang=js"

import "./AkahonSideMenu.vue?vue&type=style&index=0&id=4c223664&lang=css"

import exportComponent from "/github/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__